import React from "react";
import css from "./FirstLetter.module.css"
import IntlText, {IntlTextType} from "../intl/IntlText";

export default function FirstLetter({value}: { value: IntlTextType }) {
    return <span className={css.span}>
        <IntlText text={value}/>
    </span>
}